// extracted by mini-css-extract-plugin
export var arrow = "_lo-1";
export var content = "_lo-0";
export var highlighted = "_lo-2";